import script from "./SecondBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondBtn.vue?vue&type=script&setup=true&lang=js"

import "./SecondBtn.vue?vue&type=style&index=0&id=23b05a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b05a4c"]])

export default __exports__